import { Lead } from 'models/Leads';
import { Template } from 'models/Templates';
import { getLanguageCode } from 'utils/languageUtils';

const useTemplateModalFormInitialValue = () => {
  return ({
    lead,
    template,
    to,
    sendCopyToAgency,
  }: {
    lead?: Lead;
    template: Template;
    to: string[];
    sendCopyToAgency: boolean;
  }) => {
    const defaultLocale = 'en';

    const leadLocale = getLanguageCode(lead?.preferredLocale);

    const localeToUse =
      leadLocale &&
      template.contents.find(
        (localeTemplate) => localeTemplate.locale === leadLocale,
      )
        ? leadLocale
        : defaultLocale;

    const localeTemplate = template.contents.find(
      (content) => content.locale === localeToUse,
    );

    return {
      leadUid: lead?.uid,
      // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      subject: localeTemplate.title,
      // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      content: localeTemplate.content,
      to: to[0],
      sendCopyToAgency,
    };
  };
};

export default useTemplateModalFormInitialValue;
